import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  ManuallyConfirmationStatusType } from "../../../enums/index";

import {
  GetLineStateText,
  GetLineStateClassLineCore,
  GetLineServiceText,
  GetInitialPackageText,
  SeparateCountryCodeFromNumber,
  getManuallyConfirmationStatusClass,
  getManuallyConfirmationStatusText,
  ToPersianNumber,
  DateToPersianNumber,
} from "../../../functions/index";
import Constants from "../../../constants/constants";
import { formsButtonType } from "../../../enums/index";
import FormTexts from "../../../constants/forms";
import { WarningSVG } from "../../../assets/images/svg/warning";
import KeyhanErrorModal from "./keyhanErrorModal";
import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NewLineServiceType from "../../../enums/NewLineServiceType";

function LinesTables(props) {
  const [id, setId] = useState("");

  const useStyles = makeStyles({
    tooltip: {
      background: "#333",
      borderRadius: "20px ",
      color: "#FFF",
      padding: "8px 15px",
      fontSize: "14px",
    },
  });

  const classesToolTip = useStyles();

  const titleActiveTxt = (item) => {
    let date =
      item?.persianConfirmationDate &&
      DateToPersianNumber(item?.persianConfirmationDate);
    return (
      Constants.RejectActivatedText +
      " " +
      item?.confirmationUsername +
      Constants.Because +
      " " +
      item?.rejectActivationReason +
      date
    );
  };

  const showRequestBy = (item) => {
    let _tmp =
      item?.manuallyConfirmationStatus === "Confirmed"
        ? item?.confirmationUsername
        : item?.keyhanRequesterUserEmail;
    return _tmp;
  };
  const showRequestDate = (item) => {
    return item?.manuallyConfirmationStatus === "Confirmed"
      ? DateToPersianNumber(item?.persianConfirmationDate)
      : DateToPersianNumber(item?.persianKeyhanCreateDate);
  };

  const showText = (item) => {
    let str1 = " درخواست توسط";
    let str2 = " در تاریخ ";
    let str3 = "ارسال شد ";
    let date =
      item?.manuallyConfirmationStatus === "Confirmed"
        ? item?.persianConfirmationDate
        : item?.persianKeyhanCreateDate;

    let user =
      item?.manuallyConfirmationStatus === "Confirmed"
        ? item?.confirmationUsername
        : item?.keyhanRequesterUserEmail;

    let sendRequest = str1 + user + str2 + date + str3;
    return sendRequest;
  };

  return (
    <>
      <Table responsive className="roundedCorners">
        <thead>
          <tr>
            {props.heading.map((h, index) => (
              <th key={index}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.data &&
            props.data.map((d, index) => (
              <tr key={index}>
                <td className="ltr">
                  {ToPersianNumber(
                    SeparateCountryCodeFromNumber(d?.lineNumber)
                  )}
                </td>
                <td className={d?.isEnabled ? "enabled" : "disabled"}>
                  {d?.isEnabled ? Constants.On : Constants.Off}
                </td>
                <td>
                  {GetInitialPackageText(d?.productType)}
                  {d?.isFree &&
                    Constants.AuthHistoryArray.open +
                      Constants.Free +
                      Constants.AuthHistoryArray.close}
                </td>
                <td>{NewLineServiceType(d?.lineServiceType)}</td>
                <td className={GetLineStateClassLineCore(d?.status)}>
                  {GetLineStateText(d?.status)}
                </td>
                <td>{DateToPersianNumber(d?.persianActivationDate)}</td>
                <td>{DateToPersianNumber(d?.persianExpirationDate)}</td>

                {!d.spinner ? (
                  d?.manuallyConfirmationStatus ==="NotConfirmed" ? (
                    <td
                      className={getManuallyConfirmationStatusClass(
                        d?.manuallyConfirmationStatus
                      )}
                    >
                      {d.rejectActivationReason && (
                        <div title={titleActiveTxt(d)}>
                          {Constants.RejectActivatedText + " "}
                          {d?.confirmationUsername}
                          {Constants.Because + " "}
                          {d.rejectActivationReason}
                          {d?.persianConfirmationDate &&
                            DateToPersianNumber(d?.persianConfirmationDate)}
                        </div>
                      )}

                      {d?.keyhanRequestId !== null && (
                        <span className=" d-flex justify-content-start align-items-center">
                          <span className="direction-rtl">
                            {Constants.Request} &nbsp;
                            <b className="direction-rtl">
                              {showRequestBy(d)}
                            </b>{" "}
                            &nbsp;
                            {Constants.In}
                            &nbsp;
                            {showRequestDate(d)}
                            &nbsp;
                            {Constants.Send}
                          </span>
                        </span>
                      )}
                      <div className=" d-flex justify-content-center align-items-center">
                        {!d.rejectActivationReason &&
                          !(!d?.hasKeyhanError && d?.keyhanRequestId) && (
                            <Button
                              className="submit-button big lines-button reject"
                              variant="primary"
                              onClick={(e) => props.rejectLineModal(e, d?.id)}
                            >
                              {FormTexts.Buttons(
                                formsButtonType.RejectActivation()
                              )}
                            </Button>
                          )}

                        {
                          <div
                            className=""
                            title={
                              !d?.hasKeyhanError &&
                              d?.keyhanRequestId !== null &&
                              showText(d)
                            }
                          >
                            {!d?.hasKeyhanError &&
                              d?.keyhanRequestId !== null && <br />}
                            <Button
                              className="submit-button big lines-button"
                              variant="primary"
                              disabled={
                                !d?.hasKeyhanError &&
                                d?.keyhanRequestId !== null
                              }
                              onClick={(e) => props.activateLineModal(e, d)}
                            >
                              {getManuallyConfirmationStatusText(
                                d?.manuallyConfirmationStatus
                              )}
                            </Button>
                          </div>
                        }

                        {d?.hasKeyhanError && d?.keyhanRequestId !== null && (
                          <span
                            className="icon-log"
                            onClick={() => setId(d?.keyhanRequestId)}
                          >
                            <WarningSVG />
                          </span>
                        )}
                      </div>
                    </td>
                  ) : d?.manuallyConfirmationStatus ===
                    ManuallyConfirmationStatusType.NoNeed() ? (
                    <td>
                      <span>
                        {" "}
                        {getManuallyConfirmationStatusText(
                          d?.manuallyConfirmationStatus
                        )}
                      </span>
                    </td>
                  ) : d?.confirmationUsername ? (
                    <td>
                      {d?.keyhanRequestId !== null && (
                        <span className="direction-rtl">
                          {Constants.Request} &nbsp;
                          <b className="direction-rtl">
                            {d.keyhanRequesterUserEmail}
                          </b>{" "}
                          &nbsp;
                          {Constants.In}
                          &nbsp;
                          {d?.persianKeyhanCreateDate &&
                            DateToPersianNumber(d?.persianKeyhanCreateDate)}
                          {Constants.Send}
                        </span>
                      )}
                      {d?.keyhanRequestId !== null && <br />}

                      <span className="direction-rtl">
                        {Constants.ActivatedBy} &nbsp;
                        <b className="direction-rtl">
                          {d.confirmationUsername}
                        </b>{" "}
                        &nbsp;
                        {Constants.In}
                        &nbsp;
                        {d?.persianConfirmationDate &&
                          DateToPersianNumber(d?.persianConfirmationDate)}
                      </span>
                    </td>
                  ) : (
                    <td>
                      <span>
                        {" "}
                        {getManuallyConfirmationStatusText(
                          d?.manuallyConfirmationStatus
                        )}
                      </span>
                    </td>
                  )
                ) : (
                  <td
                    className={getManuallyConfirmationStatusClass(
                      d?.manuallyConfirmationStatus
                    )}
                  >
                    <Button
                      className="submit-button big lines-button"
                      variant="primary"
                    >
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </Button>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </Table>
      {id && <KeyhanErrorModal id={id} setId={setId} />}
    </>
  );
}
export default LinesTables;
